module.exports = __webpack_public_path__ + "media/images/tiedye/design-5-eb818015fc3c7f92784d4183ae447172.jpg";